import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { onCLS, onFCP, onLCP, onTTFB } from "web-vitals";
import App from "./App.tsx";
import "./index.css";

// Reportar Web Vitals para Sentry
function reportWebVitals() {
  const sendToSentry = (metric: {
    name: string;
    value: number;
    id: string;
  }) => {
    Sentry.addBreadcrumb({
      category: "web-vitals",
      message: `${metric.name}: ${metric.value}`,
      level: "info",
      data: {
        name: metric.name,
        value: metric.value,
        id: metric.id,
      },
    });
  };

  onCLS(sendToSentry);
  onFCP(sendToSentry);
  onLCP(sendToSentry);
  onTTFB(sendToSentry);
}

// Initialize Sentry only in production
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });

  // Reportar Web Vitals após Sentry inicializado
  reportWebVitals();
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
